import {filter} from 'rxjs/operators';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {Injectable} from '@angular/core';
import {IBreadcrumb} from '../../shared/breadcrumb/breadcrumb.model';


@Injectable()
export class BreadcrumbService {

  breadcrumbHolder: IBreadcrumb[];
  ROUTE_DATA_BREADCRUMB = "breadcrumb";
  ROUTE_DATA_BCLEVEL = "breadcrumbStatus";
  breadcrumbAdded: boolean;


  constructor(private router: Router,
              private activatedRoute: ActivatedRoute) {
    this.breadcrumbHolder = [];
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).forEach(e => {
      this.breadcrumbAdded = false;
      this.calculateBreadcrumbs(activatedRoute.root.firstChild);
    });
  }


  calculateBreadcrumbs(route: ActivatedRoute) {
    const children: ActivatedRoute[] = route.children;
    for (const child of children) {
      if (child.outlet !== "primary") {
        continue;
      }
      this.calculateBreadcrumbs(child);
      if (this.breadcrumbAdded) {
        return;
      }
      if (child.snapshot.data.hasOwnProperty(this.ROUTE_DATA_BREADCRUMB)) {
        this.addBreadcrumb(child);
        return;
      }
    }
    this.resetActiveStatus();
  }


  addBreadcrumb(child: ActivatedRoute) {

    this.resetActiveStatus();

    const breadcrumb: IBreadcrumb = {
      label: child.snapshot.data[this.ROUTE_DATA_BREADCRUMB],
      url: this.router.url,
      active: true
    };

    if (child.snapshot.data[this.ROUTE_DATA_BCLEVEL] === "firstLevel") {
      this.breadcrumbHolder = [];
    }
    if (child.snapshot.data[this.ROUTE_DATA_BCLEVEL] === "secondLevel") {
      if (this.breadcrumbHolder.length === 2) {
        this.breadcrumbHolder.pop();
      } else {
        this.removeExisting(child.snapshot.data[this.ROUTE_DATA_BREADCRUMB]);
      }
    }
    this.breadcrumbHolder.push(breadcrumb);
    this.breadcrumbAdded = true;
  }

  removeExisting(label: string) {
    for (const breadcrumb of this.breadcrumbHolder) {

      if (breadcrumb.label === label) {
        const index = this.breadcrumbHolder.indexOf(breadcrumb, 0);
        if (index > -1) {
          this.breadcrumbHolder.splice(index, 1);
        }
      }
    }
  }

  resetActiveStatus() {
    for (const breadcrumb of this.breadcrumbHolder) {
      breadcrumb.active = false;
    }
  }

  getBreadcrumbs() {
    return this.breadcrumbHolder;
  }

}
